import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { OfferCardDataDriver } from '../offer-card-data.model';


@Component({
  selector: 'outstanding-driver',
  template: `
      <span class="eva-3-driver offer-card-main-driver {{topClassName}}" [ngClass]="outstandingDriverData.driver_style"
            *ngIf="outstandingDriverData">
        <span class="driver-text" [ngClass]="outstandingDriverData.text_style">
          <img *ngIf="outstandingDriverData.icon_src"
            [ngClass]="outstandingDriverData.icon ? outstandingDriverData.icon : ''"
            [src]="'/landings-static/' + outstandingDriverData.icon_src"
            loading="lazy"
            alt="">
          <i class="-eva-3-mr-xsm" [ngClass]="outstandingDriverData.icon"
              *ngIf="outstandingDriverData.icon && !outstandingDriverData.icon_src"></i>
          {{outstandingDriverData.text | titlecase}}
        </span>
      </span>
  `,
  styleUrls: ['./outstanding-driver.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OutstandingDriverComponent implements OnInit {

  @Input() outstandingDriverData: OfferCardDataDriver;
  @Input() isTopPosition: boolean = false;

  topClassName: string;

  ngOnInit(): void {
    this.topClassName = this.isTopPosition ? '-top' : '';

  }
}
